if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();
        // ModalDialog closes the lightbox on mouse pointerup anywhere in the modal
        // (global.js). Stop the arrows' pointerup ON THE BUTTON so it still reaches
        // the arrow (the click fires and pages the image) but never bubbles up to the
        // modal's close handler. Doing this in the capture phase instead would starve
        // the button of its own pointerup and suppress the click.
        this.querySelectorAll('[data-modal-prev], [data-modal-next]').forEach((btn) => {
          btn.addEventListener('pointerup', (event) => event.stopPropagation());
        });
      }

      // Move the active zoomed image by `dir` (+1 next, -1 prev), wrapping around.
      // On mobile only the active item is shown, so this swaps the visible image;
      // on desktop all are shown, so it scrolls the stack to the target.
      navigate(dir) {
        const items = Array.from(this.querySelectorAll('[role="document"] > [data-media-id]'));
        if (items.length < 2) return;
        let idx = items.findIndex((el) => el.classList.contains('active'));
        if (idx < 0) idx = 0;
        let next = (idx + dir + items.length) % items.length;
        items.forEach((el) => el.classList.remove('active'));
        const target = items[next];
        target.classList.add('active');
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  );

  // Delegated so the arrows work regardless of when the modal markup is added.
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-modal-prev], [data-modal-next]');
    if (!btn) return;
    const modal = btn.closest('product-modal');
    if (!modal || typeof modal.navigate !== 'function') return;
    modal.navigate(btn.hasAttribute('data-modal-next') ? 1 : -1);
  });

}
